import { render, staticRenderFns } from "./ModalShareActions.vue?vue&type=template&id=2f9dfa5b&"
import script from "./ModalShareActions.vue?vue&type=script&lang=js&"
export * from "./ModalShareActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports